<template>
  <div class="row" v-if="leaveData">
    <div class="col_12">
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div class="form_row_inline">
                <label class="">Name</label>
                <div class="form_input">{{ leaveData?.user?.name }}</div>
              </div>
              <div class="form_row_inline">
                <label class="">Start date</label>
                <div class="form_input">{{ leaveData?.start_date }}</div>
              </div>
              <div class="form_row_inline">
                <label class="">End date</label>
                <div class="form_input">{{ leaveData?.end_date }}</div>
              </div>
              <div class="form_row_inline">
                <label class="">Leave type</label>
                <div class="form_input">{{ leaveData?.leave_type }}</div>
              </div>
              <div
                :class="['form_row_inline', { has_error: errorFor('status') }]"
              >
                <label>Status</label>
                <div class="form_input">
                  <select class="form_global" v-model="form.status">
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                  </select>
                  <v-errors :errors="errorFor('status')"></v-errors>
                </div>
              </div>
              <div class="form_row_inline">
                <label></label>
                <div class="form_input">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
            <div class="col_6 pr_20">
              <div class="form_row_inline" v-if="leaveData?.reason">
                <label class="">Reason</label>
                <div class="form_input">{{ leaveData?.reason }}</div>
              </div>
              <div v-if="leaveData?.document">
                <h3>
                  Document
                  <span
                    class="float-right"
                    title="Download document"
                    @click.prevent="downloadFile(leaveData?.document)"
                    ><i class="lni lni-download"></i
                  ></span>
                </h3>
                <br />
                <img :src="leaveData?.document" width="100%" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'leave-details',
  components: {},
  props: {
    leaveData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lyLoading: false,
      form: {
        status: this.leaveData?.status,
      },
    };
  },
  created() {},
  methods: {
    downloadFile(filePath) {
      const a = document.createElement('a');
      a.href = filePath;
      let filenameArr = filePath.split('/');
      let filename = filenameArr[filenameArr.length - 1];
      a.download = filename;
      a.style.display = `none`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/leaves/' + this.leaveData.id, formData)
        .then(() => {
          this.showSuccessMsg('Leave Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
.float-right {
  float: right;
  cursor: pointer;
}
</style>
